import { SubmissionObjectEffects } from './objects/submission-objects.effects';

export const submissionEffects = [
  SubmissionObjectEffects,
];
